import { render } from "./input-field.vue?vue&type=template&id=049369e8&ts=true"
import script from "./input-field.vue?vue&type=script&lang=ts"
export * from "./input-field.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__